import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface ToggleFieldProps extends FormlyFieldProps {
  type?: 'inline' | 'divided' | 'icon';
  icon?: string;
}

@Component({
  selector: 'toggle-field',
  standalone: true,
  imports: [...FORM_IMPORTS, ToggleSwitch],
  template: `
    <p-toggleswitch [formControl]="formControl" [formlyAttributes]="field" />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleFieldType extends FieldType<
  FieldTypeConfig<ToggleFieldProps>
> {}
